<router-outlet />
<!-- <app-explore-mode-output></app-explore-mode-output> -->
<!-- <app-pop-up></app-pop-up> -->
